import styled from "react-emotion";

export const Wrapper = styled("div")`
  display: flex;
  height: calc(100vh - 40px);
`;
